module.exports = __webpack_public_path__ + "img/09.ea16a700.jpg";